import React from 'react';
import { Button, Icon, Message, Modal } from 'semantic-ui-react';
import './AreaClienteModal.css';

function getContatoNome(contato) {
    return contato.nomewpp || contato.nomecontato || 'Contato sem nome';
}

function getContatoNumero(contato) {
    return contato.wpp || contato.ad_whatsappcp || '';
}

function AreaClienteModal({
    open,
    contatos,
    cliente,
    loading,
    loadingContato,
    error,
    fallbackUrl,
    onClose,
    onSend
}) {
    function handleClose() {
        onClose();
    }

    return (
        <Modal
            className="area-cliente-modal"
            open={open}
            onClose={handleClose}
            size="tiny"
            closeIcon
        >
            <Modal.Header>Enviar &Aacute;rea do Cliente</Modal.Header>
            <Modal.Content>
                <div className="area-cliente-modal-subtitle">
                    Toque em enviar no contato que recebera o link de {cliente || 'este cliente'}.
                </div>

                {error ? (
                    <Message negative>
                        <Message.Header>Nao foi possivel abrir o WhatsApp</Message.Header>
                        <p>{error}</p>
                        {fallbackUrl ? (
                            <a
                                className="area-cliente-fallback-link"
                                href={fallbackUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Abrir link manualmente
                            </a>
                        ) : null}
                    </Message>
                ) : null}

                <div className="area-cliente-contact-list">
                    {contatos.map(contato => {
                        const chips = [];

                        if (contato.ad_isprincipal === 'S') chips.push('Principal');
                        if (contato.ad_iscomercial === 'S') chips.push('Comercial');
                        if (contato.ad_iscentregas === 'S') chips.push('Entregas');
                        if (contato.ad_isnfe === 'S') chips.push('NFe');
                        const contatoLoadingId = contato.codcontato || getContatoNumero(contato);
                        const isContatoLoading = loadingContato === contatoLoadingId;

                        return (
                            <div
                                key={contato.codcontato}
                                className="area-cliente-contact"
                            >
                                <span className="area-cliente-contact-title">
                                    <span>{getContatoNome(contato)}</span>
                                    <Icon name="user circle" />
                                </span>
                                <span className="area-cliente-contact-number">
                                    <Icon name="whatsapp" /> {getContatoNumero(contato)}
                                </span>
                                {contato.emailwpp || contato.email ? (
                                    <span className="area-cliente-contact-meta">{contato.emailwpp || contato.email}</span>
                                ) : null}
                                {chips.length > 0 ? (
                                    <span className="area-cliente-chip-row">
                                        {chips.map(chip => (
                                            <span key={chip} className="area-cliente-chip">{chip}</span>
                                        ))}
                                    </span>
                                ) : null}
                                <Button
                                    type="button"
                                    color="green"
                                    fluid
                                    loading={isContatoLoading}
                                    disabled={loading}
                                    onClick={() => onSend(contato)}
                                >
                                    <Icon name="whatsapp" />
                                    Enviar pelo WhatsApp
                                </Button>
                            </div>
                        );
                    })}
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button type="button" onClick={handleClose} disabled={loading}>
                    Cancelar
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default AreaClienteModal;
